
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/miniprojetos",
      function () {
        return require("private-next-pages/projects/miniprojetos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/miniprojetos"])
      });
    }
  